<template>
  <prop :name="propName">
    <router-link :to="{name: this.type + 'Detail', params: {id: this.id}}">
      <slot></slot>
    </router-link>
  </prop>
</template>

<script>
import {getTypeName} from "@/utils/business-objects";
import Prop from "@/layouts/Prop";

export default {
  components: {Prop},
  props: {
    type: String,
    id: String,
    name: String
  },
  computed: {
    propName() {
      return this.name ? this.name : getTypeName(this.type)
    }
  }
}
</script>
